import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "linkFields", "fileFields", "contentFields"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const reportType = this.typeSelectTarget.value

    this.linkFieldsTargets.forEach(field => {
      field.style.display = reportType === 'link' ? 'block' : 'none'
    })

    this.fileFieldsTargets.forEach(field => {
      field.style.display = reportType === 'document' ? 'block' : 'none'
    })

    this.contentFieldsTargets.forEach(field => {
      field.style.display = reportType === 'content_page' ? 'block' : 'none'
    })
  }
}